var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Head',{attrs:{"active":'home'}}),_vm._v(" "),_c('floatright'),_vm._v(" "),_c('banner'),_vm._v(" "),_c('introduction'),_vm._v(" "),_c('cont'),_vm._v(" "),_c('center'),_vm._v(" "),_c('new'),_vm._v(" "),_c('join'),_vm._v(" "),_c('cooperative'),_vm._v(" "),_c('inner'),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-300b9c45","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/index-hbcj.vue
// module id = null
// module chunks = 